import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function departureTimeFiltered({
    searchParams = {},
    totalTrips,
    value,
}) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    const property = {
        hours: value,
        num_trips: totalTrips,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: 'time_depart',
        property,
    });

    amplitude.track('Search Filtered', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        filter_type: 'departure_time',
        results_count_before: totalTrips,
        ui_source: 'sidebar_filter',
        updated_to: value,
    });
}

function arrivalTimeFiltered({
    searchParams = {},
    totalTrips,
    value,
}) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    const property = {
        hours: value,
        num_trips: totalTrips,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: 'time_arrive',
        property,
    });

    amplitude.track('Search Filtered', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        filter_type: 'arrival_time',
        results_count_before: totalTrips,
        ui_source: 'sidebar_filter',
        updated_to: value,
    });
}

export default {
    arrivalTimeFiltered,
    departureTimeFiltered,
};
